import Vue from "vue";
import moment from "moment";

// 格式化日期时间
Vue.filter("formatDateTime", (value, format = "YYYY-MM-DD HH:mm:ss") => {
  if (!value) return "";
  return moment(value).format(format);
});

// 格式化日期
Vue.filter("formatDate", (value, format = "YYYY-MM-DD") => {
  if (!value) return "";
  return moment(value).format(format);
});

// 格式化文件大小
Vue.filter("formatFileSize", (bytes) => {
  if (!bytes) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
});

// 状态格式化
Vue.filter("formatStatus", (status) => {
  const statusMap = {
    0: "禁用",
    1: "启用",
    active: "活跃",
    inactive: "非活跃",
  };
  return statusMap[status] || status;
});

// 用户角色格式化
Vue.filter("formatUserRole", (role) => {
  const roleMap = {
    super_admin: "超级管理员",
    admin: "管理员",
    viewer: "只读管理员",
  };
  return roleMap[role] || role;
});

// 任务类型格式化
Vue.filter("formatTaskType", (type) => {
  const typeMap = {
    choice: "选择题",
    image: "图片上传",
    video: "视频上传",
  };
  return typeMap[type] || type;
});

// 数字格式化（千分位）
Vue.filter("formatNumber", (num) => {
  if (!num && num !== 0) return "";
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});
